import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { Link } from 'react-router-dom';

export const IDCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;

  return (
    <td {...props.tdProps}>
      <Link
        to={`/PurchaseOrder/Index/${props.dataItem.PurchaseOrderNumber}`}
        onClick={() => window.scrollTo(0, 0)}
        style={{ color: '#007bff' }}
      >
        {props.dataItem[props.field]}
      </Link>
    </td>
  );
}
